import RegisterPage from "./pages/FrontPage/RegisterPage";
import LoginPage from "./pages/FrontPage/LoginPage";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import WelcomePage from "./pages/FrontPage/WelcomePage";
import { useState, createContext, useMemo } from "react";
import { Context } from "./Context";
import LinkPlatform from "./LinkPlatform";
import SiteLayout from "./SiteLayout";
import SupportedPlatforms from "./pages/SupportedPlatforms";
import Profile from "./pages/Profile/Profile";
import UserDetails from "./pages/Profile/UserDetails";
import ManagePlatforms from "./pages/ManagePlatforms";
import SwyftxDashboard from "./pages/SwyftxDashboard";
import AboutPage from "./pages/AboutPage";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import Donut from "./Donut";
import Forbidden from "./pages/ErrorPages/Forbidden";
import NotFound from "./pages/ErrorPages/NotFound";
import CommbankHomePage from "./pages/CommbankHomePage";
import { HelmetProvider } from "react-helmet-async";
import SelfwealthDashboard from "./pages/SelfwealthDashboard";

export const makeTheme = (mode) => {
    let theme = {
        palette: {
            mode: mode,
            ...(mode === "dark"
                ? {
                      primary: {
                          main: "#30302f",
                          dark: "#212020",
                          light: "#EEEEEE",
                          contrastText: "white",
                      },
                      secondary: {
                          main: "#EEEEEE",
                      },
                      info: {
                          main: "#0288d1",
                      },
                  }
                : {
                      primary: {
                          main: "#dbd5c3",
                          dark: "#f1e9d6",
                          light: "#FFFFFF",
                          contrastText: "#000000",
                      },
                      secondary: {
                          main: "#000000",
                      },
                  }),
        },
        typography: {
            fontFamily: ["Tilt Warp", "sans-serif"].join(","),
        },
    };

    return theme;
};

// context for color mode
export const ColorModeContext = createContext({
    toggleColorMode: () => {},
});

export const useMode = () => {
    const [mode, setMode] = useState("dark");

    const colorMode = useMemo(
        () => ({
            toggleColorMode: () =>
                setMode((prev) => (prev === "light" ? "dark" : "light")),
        }),
        []
    );

    const theme = useMemo(() => createTheme(makeTheme(mode)), [mode]);
    return [theme, colorMode];
};

function App() {
    const [auth, setAuth] = useState(localStorage.getItem("token"));
    const [effect, setEffect] = useState();
    const [userName, setUserName] = useState(localStorage.getItem("name"));
    const [theme, colorMode] = useMode();
    const helmetContext = {};

    return (
        <HelmetProvider context={helmetContext}>
            <ColorModeContext.Provider value={colorMode}>
                <ThemeProvider theme={theme}>
                    <title>WealthWatch</title>
                    <meta charSet="UTF-8" />
                    <meta
                        name="viewport"
                        content="width=device-width"
                        initial-scvale={1.0}
                    />
                    <Context.Provider
                        value={{
                            auth,
                            setAuth,
                            effect,
                            setEffect,
                            userName,
                            setUserName,
                        }}
                    >
                        <BrowserRouter>
                            <Routes>
                                <Route path="about" element={<AboutPage />} />
                                <Route element={<WelcomePage />}>
                                    <Route
                                        path="login"
                                        element={<LoginPage />}
                                    />
                                    <Route
                                        path="signup"
                                        element={<RegisterPage />}
                                    />
                                    <Route index element={<LoginPage />} />
                                </Route>
                                <Route element={<SiteLayout />}>
                                    <Route path="*" element={<NotFound />} />
                                    <Route path="403" element={<Forbidden />} />
                                    <Route path="dashboard">
                                        <Route
                                            path="swyftx"
                                            element={<SwyftxDashboard />}
                                        />
                                        <Route
                                            path="commbank"
                                            element={<CommbankHomePage />}
                                        />
                                        <Route
                                            path="selfwealth"
                                            element={<SelfwealthDashboard />}
                                        />
                                        <Route index element={<Donut />} />
                                    </Route>
                                    <Route path="link">
                                        <Route
                                            path=":platform"
                                            element={<LinkPlatform />}
                                        />
                                        <Route
                                            index
                                            element={<SupportedPlatforms />}
                                        />
                                    </Route>
                                    <Route path="profile">
                                        <Route
                                            path="details"
                                            element={<UserDetails />}
                                        />
                                        <Route
                                            path="manage-links"
                                            element={<ManagePlatforms />}
                                        ></Route>
                                        <Route index element={<Profile />} />
                                    </Route>
                                </Route>
                            </Routes>
                        </BrowserRouter>
                    </Context.Provider>
                </ThemeProvider>
            </ColorModeContext.Provider>
        </HelmetProvider>
    );
}
export default App;
